const SelfMessage = ({ text }) => {
  return (
    <div className="flex justify-end gap-3">
      <div className="flex flex-col items-end">
        <p className="font-pop text-xs font-medium text-blue">Me</p>
        <p className="my-1 rounded-[10px] rounded-tr-none bg-secondary px-3 py-[5px] font-pop text-xl text-white">
          {text}
        </p>
        <p className="font-pop text-xs text-chatLightGray">
          12 July 2022, 02:03:28 am
        </p>
      </div>
    </div>
  );
};

export default SelfMessage;
